<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <div class="col-sm-12">
        <ShippingMethodTransportationForm
          v-if="shippingMethodTransportation"
          :shippingMethodTransportation="shippingMethodTransportation"
        />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import ShippingMethodTransportationForm from "@/components/settings/test-registers/shippingmethodtransportation/ShippingMethodTransportationForm.vue";

export default {
  name: "ShippingMethodTransportationEdit",

  components: {
    PageTitle,
    PageRowWrapper,
    ShippingMethodTransportationForm,
  },

  computed: {
    ...mapState({
      shippingMethodTransportation: (state) => state.shippingmethodtransportation.shippingMethodTransportation,
    }),
  },

  methods: {
    ...mapActions("shippingmethodtransportation", ["fetchById"]),
  },

  mounted() {
    this.fetchById(this.$route.params.id);
  },
};
</script>
